import { Link } from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import useDocumentTitle from "../../hooks/useDocumentTitle";

const FailedPage = () => {
	useDocumentTitle("Ανεπιτυχής επικύρωση εισιτηρίου");

	return (
		<MainContainer>
			<div className="col-lg-8">
				<div className="success-icon mb-3">
					<svg xmlns="http://www.w3.org/2000/svg" fill="#198754" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
						<path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" />
					</svg>
				</div>
				<h1 className="mb-4">Ανεπιτυχής επικύρωση εισιτηρίου</h1>
				<div className="p-4 border bg-body-tertiary border-success rounded mb-4">
					<p className="mb-0">
						Το εισιτήριο με κωδικό <strong>234567898765432</strong> έχει πρoστεθεί στο Gov.gr Wallet του χρήστη{" "}
						<strong>Jason Smith</strong>.
					</p>
				</div>
				<Link to="/ticket-office/choose-user" className="btn btn-primary btn-lg">
					Προσθήκη νέου εισιτηρίου
				</Link>
			</div>
		</MainContainer>
	);
};

export default FailedPage;
